module.exports = __webpack_public_path__ + "static/img/chasha.9a966b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chasha.jpg
// module id = olMb
// module chunks = 1